import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
// import AddCircleIcon from '@material-ui/icons/AddCircle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import { Card, CardActions, Button, CardContent, CardMedia, Grid } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';

import Papa from 'papaparse';

const styles = (theme) => ({
	content: {
				flexGrow: 1,
				// padding: theme.spacing(3),
		},
		p: {
			display: 'block',
		},
	// title: {
	// 	marginLeft: theme.spacing(2),
	// 	flex: 1,
	// 	color: "#222"
	// },
	root: {
		flexGrow : 1,
		background: 'transparent',
	},
	pos: {
		paddingRight: 12
	},
	uiProgess: {
		position: 'fixed',
		zIndex: '1000',
		height: '31px',
		width: '31px',
		left: '50%',
		top: '35%'
	},
	dialogStyle: {
		maxWidth: '60%'
	},
	viewRoot: {
		margin: 0,
		padding: theme.spacing(2)
	},
	closeButton: {
		position: 'absolute',
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500]
	},
	media: {
			height: 250,
			cursor: 'pointer'
	},
	tags: {
		display: 'flex',
		justifyContent: 'flex-start',
		flexWrap: 'wrap',
		'& > *': {
			margin: theme.spacing(0.5),
		},
	},
	icon: {
		// color: 'rgba(255, 255, 255, 0.54)',
		color: 'white',
	},
	lexiconText: {
		fontFamily: ['Courier', "sans-serif"].join(','),
		textDecoration: "none",
	},
});


// const Transition = React.forwardRef(function Transition(props, ref) {
// 	return <Slide direction="up" ref={ref} {...props} />;
// });

function Proper(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

class lexicon_media extends Component {

	constructor(props) {
		super(props);

		this.state = {
			media: '',
			errors: [],
			filters: {
				active: true,
				created_by: '',
				category: 'movement',
				sort: 'Name'
			},
			// open: false,
			uiLoading: true,
			buttonType: '',
			viewOpen: false,
		};

		this.handleViewOpen = this.handleViewOpen.bind(this);
		this.updateData = this.updateData.bind(this);
	}
  
	handleChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value
		});
	};

	handleViewOpen(data) {
		this.setState({
			active: true,
			media_type: data.item.Category.toLowerCase(),
			media_name: data.item.media_name,
			media_filename: data.item?.['Filename'],
			description: data.item?.['Movement Instruction'],
			lexicon: {
				aesthetics: data.item?.['Style'],
				body_direction: data.item?.['Body direction'],
				movement: data.item?.['Movement Category'],	
				body_part: data.item?.['Material/Body part'],	
				tension: data.item?.['Movement quality-tension'],	
				emotional_effect: data.item?.['Mood/Emotional association to the gesture'],	
				meaning: data.item?.['Meaning behind the movement'],	
				spatial_level: data.item?.['Spatial level, Stationary/traveling/traveling big, Weight shift, Body direction changes'],	
				spatial_range: data.item?.['Spatial range/ size of the movement'],	
				size: data.item?.['Spatial range/ size of the movement'],
				tags: data.item?.['tags']
			},
			viewOpen: true
		});
	}

	componentDidMount = () => {
		Papa.parse("/database.csv",
			{
				download: true,
				header: true,
				workder: true,
				skipEmptyLines: true,
				complete: this.updateData
				});

	};
	updateData(results){
		this.setState({ media: results.data
									, searchResults: results.data
									, uiLoading: false
									, menu: {
											movement_categories: Array.from(new Set(results.data.map((x) => x['Movement Category']))),
											movement_moods: Array.from(new Set(results.data.flatMap((x) => x['Mood/Emotional association to the gesture'].replace(/\n/g, '').split(',').map(x => x.trim())))).sort(),
											body_tension: Array.from(new Set(results.data.flatMap((x) => x['Movement quality-tension'].toLowerCase().replace(/\n/g, '').split(',').map(x => x.trim())))).sort(),
											spatial_level: Array.from(new Set(results.data.flatMap((x) => x['Spatial level, Stationary/traveling/traveling big, Weight shift, Body direction changes'].toLowerCase().replace(/\n/g, '').split(',').map(x => x.trim())))).sort(),
											spatial_range: Array.from(new Set(results.data.flatMap((x) => x['Spatial range/ size of the movement'].toLowerCase().replace(/\n/g, '').split(',').map(x => x.trim())))).sort(),
											filter: { query: '' }	
									}
									}, () => {
										// console.log(this.state.menu.movement_categories);
									});
	}


	render() {
		const baseurl = "https://storage.googleapis.com/mimo-cat-f82c7";

		const { classes } = this.props;
		const { menu } = this.state; 

		// const handleClickOpen = () => {
		// 	this.setState({
		// 		id: '',
		// 		active: '',
		// 		media_name: '',
		// 		media_filename: '',
		// 		media_tags: '',
		// 		media_category: '',
		// 		buttonType: '',
		// 		open: true
		// 	});
		// };


		// const handleClose = (event) => {
		// 	this.setState({ open: false });
		// };

		if (this.state.uiLoading === true) {
			return (
				<main className={classes.content}>
					{this.state.uiLoading && <CircularProgress size={150} className={classes.uiProgess} />}
				</main>
			);
		} else {
			
			return (
				<main className={classes.content}>
					<Route exact path="/lexicon">
						<Grid container spacing={2} key="home-main" justifyContent="center" >
						<Grid item xs={12} sm={6} md={4}>
						
						<Typography variant="h5" component="h2">Categories</Typography>
						<ul>
							{menu.movement_categories.sort().map((item,index) => (
								<li key={index+item}>
								<Typography component="a" href={`/lexicon/category/`+item.toLowerCase()} value={index} key={item+"c"} name={item} className={classes.lexiconText} color="textSecondary">{item.trim()}</Typography>
								</li>

							))}
							</ul>
							<br/>

						<Typography variant="h5" component="h2">Body Tension</Typography>
						<ul>
							{menu.body_tension.sort().map((item,index) => (
								item!=="" ?
								<li key={index+item}>
								<Typography component="a" href={`/lexicon/tension/`+item.toLowerCase()} value={index} key={item+"c"} name={item} className={classes.lexiconText} color="textSecondary">{toTitleCase(item.trim())}</Typography>
								</li>
								: ""
							))}
							</ul>
							<br/>

							<Typography variant="h5" component="h2">Spatial Level</Typography>
						<ul>
							{menu.spatial_level.sort().map((item,index) => (
								item!=="" ?
								<li key={index+item}>
								<Typography component="a" href={`/lexicon/spatial_level/`+item.toLowerCase()} value={index} key={item+"c"} name={item} className={classes.lexiconText} color="textSecondary">{toTitleCase(item.trim())}</Typography>
								</li>
								: ""
							))}
							</ul>
							<br/>

							<Typography variant="h5" component="h2">Spatial Range</Typography>
						<ul>
							{menu.spatial_range.sort().map((item,index) => (
								item!=="" ?
								<li key={index+item}>
								<Typography component="a" href={`/lexicon/spatial_range/`+item.toLowerCase()} value={index} key={item+"c"} name={item} className={classes.lexiconText} color="textSecondary">{toTitleCase(item.trim())}</Typography>
								</li>
								: ""
							))}
							</ul>
							<br/>

						<Typography variant="h5" component="h2" color="textStandard">Mood</Typography>
						<ul>
							{menu.movement_moods.filter(x => x.trim() !== '' ).map((item,index) =>
									<li key={index+item}>
										<Typography component="a" href={`/lexicon/mood/`+item.trim().toLowerCase()} value={index} key={item+"m"} name={item.trim()} className={classes.lexiconText} color="textSecondary">{item.trim()}</Typography>
									</li>
							)}
						</ul>
							</Grid>
						</Grid>
					</Route>
					<Switch>
						<Route path="/lexicon/category/:cat" 
							children={({ match, ...rest }) => (
								<CategoryClips baseurl={baseurl} media={this.state.media.filter(item => item.['Movement Category'].toLowerCase() === match.params.cat)} name={toTitleCase(match.params.cat)} {...rest} />
							)} 
						/>
						<Route path="/lexicon/mood/:mood" 
							children={({ match, ...rest }) => (
								<CategoryClips baseurl={baseurl} media={this.state.media.filter(item => item.['Mood/Emotional association to the gesture'].toLowerCase().match(match.params.mood))} name={match.params.mood} {...rest} />
							)} 
						/>
						<Route path="/lexicon/tension/:id" 
							children={({ match, ...rest }) => (
								<CategoryClips baseurl={baseurl} media={this.state.media.filter(item => item.['Movement quality-tension'].toLowerCase().match(match.params.id))} name={match.params.id} {...rest} />
							)} 
						/>
						<Route path="/lexicon/spatial_level/:id" 
							children={({ match, ...rest }) => (
								<CategoryClips baseurl={baseurl} media={this.state.media.filter(item => item.['Spatial level, Stationary/traveling/traveling big, Weight shift, Body direction changes'].toLowerCase().match(match.params.id))} name={match.params.id} {...rest} />
							)} 
						/>
						<Route path="/lexicon/spatial_range/:id" 
							children={({ match, ...rest }) => (
								<CategoryClips baseurl={baseurl} media={this.state.media.filter(item => item.['Spatial range/ size of the movement'].toLowerCase().match(match.params.id))} name={match.params.id} {...rest} />
							)} 
						/>
					</Switch>
			
				</main>
			);
		}
	}
}

export default (withStyles(styles)(lexicon_media));


const Pair = withStyles(styles)((props) => {
	const { classes } = props;
	return (<div style={{display:"flex"}}>
				<Typography className={classes.pos} color="textSecondary" component="p" variant="overline" display="inline" noWrap>
					{props.left}
				</Typography>
				<Typography variant="overline" component="p" display="inline"  style={{color: "#495057"}} noWrap>
					{props.right}
				</Typography>
				</div>
	);
});

const PairWithTags = withStyles(styles)((props) => {
	const { classes } = props;
	return (<div style={{display:"flex"}}>
				<Typography className={classes.pos} color="textSecondary" component="p" variant="overline" display="inline" noWrap>
					{props.left}
				</Typography>
				{props.right.split(",").map((item,index) => (
							item!=="" ?
							<>
							<Typography component="a" variant="overline"  href={props.lex+item.toLowerCase().trim()} value={index} key={item+"c"} name={item} style={{color: "#9c70ca", textDecoration: 'none'}} >{item.trim()}{', '}</Typography>
							<Typography component="body">{' '}</Typography>
							</>
							: ""
						)
					)}
				
				</div>
	);
});

class CategoryClips extends React.Component {
	
	constructor(props) {
		super(props);
		
		this.state = {
			open: false,
			displaySet: this.props.media,
			lexicon: {
				aesthetics: "",
				body_direction: "",
				movement: "",
				body_part: "",
				tension: "",	
				emotional_effect: "",
				meaning: "",	
				spatial_level: "",	
				spatial_range: "",
				size: "",
				tags: "",
			},
		};

		// console.log(this.props);
		this.handleViewClose = this.handleViewClose.bind(this);
		this.handlePreview = this.handlePreview.bind(this);
	}
	componentDidMount() {
  }

  componentWillUnmount() {
  }

	handlePreview(data) {
		this.setState({
			media_filename: data.filename,
			media_type: data.['Movement Category'],
			media_name: data.['Name'],
			description: data.['Movement Instruction'],
			media_item: data.Category.replace(/Japanese Movement/g,'clips').toLowerCase() + "/" + data.Filename,
			lexicon: {
				aesthetics: data.['Style'],
				body_direction: data.['Body direction'],
				movement: data.['Movement Category'],	
				body_part: data.['Material/Body part'],	
				tension: data.['Movement quality-tension'],	
				emotional_effect: data.['Mood/Emotional association to the gesture'],	
				meaning: data.['Meaning behind the movement'],	
				spatial_level: data.['Spatial level, Stationary/traveling/traveling big, Weight shift, Body direction changes'],	
				spatial_range: data.['Spatial range/ size of the movement'],	
				size: data.['Spatial range/ size of the movement'],
				tags: data.['tags']
			},
			open: true
		}, () => {
			console.log(this.state.lexicon.movement);
		});
	}

	handleViewClose() {
		this.setState({ open: false });
	}


	
	render(){

		const DialogTitle = withStyles(styles)((props) => {
			const { children, classes, onClose, ...other } = props;
			return (
				<MuiDialogTitle className={classes.root} {...other}>
					<Typography vvariant="h6" style={{color:"#495057"}}>{children}</Typography>
					{onClose ? (
						<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
							<CloseIcon />
						</IconButton>
					) : null}
				</MuiDialogTitle>
			);
		});
		
		return(
	<>
	<Typography gutterBottom variant="h4" component="h2"  color="textSecondary">
		{this.props.name} 
	</Typography>
	<br />

	<Grid container spacing={2}>
		{this.state.displaySet.map((item) => (
			<Grid item xs={12} sm={6} md={4} key={item.media_name}>
				<Card variant="outlined"> 
						<CardMedia
								key={item.media_name}
								component={"img"}
								// className={classes.media}
								title={item.Filename}
								image={`${this.props.baseurl}/${item.Category.replace(/Japanese Movement/g,'clips').toLowerCase()}/thumbnail/${item.Filename.split('.')[0]}.jpg`}
						/>
					<CardContent>
					<Typography variant="h5" component="h2" style={{color: "#495057"}}>
						{item.media_name} {' '} <Typography color="textSecondary" display="inline" >({item.['Movement Category']})</Typography>
					</Typography>
					{item.Category.toLowerCase() === "movement" ? <>
					<Pair left={'Body Part: '} right={item['Material/Body part']} />
					<Pair left={'Mood: '} right={item['Mood/Emotional association to the gesture']} /></>
					: '' }
					</CardContent>
					<CardActions>
						<Button size="small" color="secondary" onClick={() => this.handlePreview( item )}>
							Learn More {' '}
						</Button>
					</CardActions>
				</Card>
			</Grid>
		))}
	</Grid>

	<Dialog
		onClose={this.handleViewClose}
		aria-labelledby="preview"
		open={this.state.open}
		fullWidth
		maxWidth={"lg"}
	>
		<DialogTitle id="movement_details-title" onClose={this.handleViewClose}>
			{this.state.media_name}
		</DialogTitle>
		
		<DialogContent dividers>	
		<Grid container spacing={3}>
			<Grid item xs={12} sm={6} md={6}>

					<CardMedia
							component="video"
							title={this.state.media_name}
							image={`${this.props.baseurl}/${this.state.media_item}`}
							// style={ {"minHeight": 400 }}
							autoPlay
							controls
					/> 

			</Grid>
			<Grid item xs={6} sm={6} md={6} container>
				<Grid item xs container direction="column" spacing={2}>
					<Grid item xs>
						<Typography gutterBottom variant="h5" component="h2" style={{color: "#495057"}}>
						{this.state.media_name}
						</Typography>
						<Pair left={'Instruction:'} right={this.state.description} />
						<PairWithTags left={'Movement:'} right={this.state.lexicon.movement} lex={'/lexicon/category/'} />
						<Pair left={'Body Part:'} right={this.state.lexicon.body_part} />
						<PairWithTags left={'Mood:'} right={this.state.lexicon.emotional_effect} lex={'/lexicon/mood/'} />
						<Pair left={'Style:'} right={this.state.lexicon.aesthetics} />
						<Pair left={'Body Direction:'} right={this.state.lexicon.body_direction} />
						<PairWithTags left={'Body Tension:'} right={this.state.lexicon.tension} lex={'/lexicon/tension/'}/>
						{/* <Pair left={'Meaning:'} right={this.state.lexicon.meaning} />  */}
						<PairWithTags left={'Spatial Level:'} right={this.state.lexicon.spatial_level} lex={'/lexicon/spatial_level/'} />
						<PairWithTags left={'Spatial Range:'} right={this.state.lexicon.spatial_range} lex={'/lexicon/spatial_range/'} />
						<Pair left={'Size :'} right={this.state.lexicon.size} />
					</Grid>
				</Grid>
			</Grid>
		</Grid>
		
		</DialogContent>
		
	</Dialog>

	</>)
	}
}

function toTitleCase(str) {
  return str.replace(
    /\w\S*/g,
    function(txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    }
  );
}